import React, { useEffect, useState } from 'react';
import { CalendarDays } from 'lucide-react';
import { MAHOTSAVA_DATE } from '../../lib/constants';
import { Diamond } from './Ornaments';

const calc = () => {
  const diff = new Date(MAHOTSAVA_DATE).getTime() - Date.now();
  if (diff <= 0) return null;
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return { d, h, m, s };
};

const Unit = ({ value, label }) => (
  <div className="flex flex-col items-center">
    <span className="font-serif text-xl leading-none text-gold md:text-2xl" data-testid={`countdown-${label}`}>
      {String(value).padStart(2, '0')}
    </span>
    <span className="mt-1 text-[9px] uppercase tracking-[0.2em] text-ivory/60">{label}</span>
  </div>
);

const CountdownBanner = () => {
  const [t, setT] = useState(calc());

  useEffect(() => {
    const id = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      data-testid="countdown-banner"
      className="relative overflow-hidden border-y border-gold/25 bg-maroon py-3 text-ivory"
    >
      <div className="velvet-noise pointer-events-none absolute inset-0 opacity-15 mix-blend-overlay" />
      <div className="relative mx-auto flex max-w-7xl flex-col items-center justify-center gap-3 px-5 sm:flex-row sm:gap-6 md:px-8">
        <div className="flex items-center gap-2.5">
          <CalendarDays className="h-4 w-4 text-gold" />
          <span className="font-sans text-xs uppercase tracking-[0.16em] text-ivory/85 md:text-sm">
            Gurupurnima Sai Baba Mahotsava · 29 July 2026
          </span>
        </div>
        <Diamond tone="#D4AF37" size={7} className="hidden sm:block" />
        {t ? (
          <div className="flex items-center gap-4">
            <Unit value={t.d} label="days" />
            <span className="text-gold/40">:</span>
            <Unit value={t.h} label="hrs" />
            <span className="text-gold/40">:</span>
            <Unit value={t.m} label="min" />
            <span className="text-gold/40">:</span>
            <Unit value={t.s} label="sec" />
          </div>
        ) : (
          <span className="font-serif text-lg text-gold">The Mahotsava is here — Om Sai Ram</span>
        )}
      </div>
    </div>
  );
};

export default CountdownBanner;
